export default "__VITE_ASSET__DuQ4bY4G__"